/** Function to update all caches, from CacheProperties.update, with the new data. */
export async function updateCache(storage, data, entries) {
    for (const cacheKey in entries) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const value = entries[cacheKey];
        if (value === 'delete') {
            await storage.remove(cacheKey);
            continue;
        }
        const oldValue = await storage.get(cacheKey);
        if (oldValue.state === 'loading') {
            continue;
        }
        const newValue = await value(oldValue, data);
        if (newValue === 'delete') {
            await storage.remove(cacheKey);
            continue;
        }
        if (newValue !== 'ignore') {
            await storage.set(cacheKey, newValue);
        }
    }
}
